import React from 'react';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdOperationsGeneralConfiguration } from '@jira/navigation-apps__constants/src/SidebarIdOperationsGeneralConfiguration.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { opsSettingsLayout } from '@jira/platform__layouts-ops-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { globalEscalationsRoute } from '@jira/router-routes__eoc-global-escalations-routes/src/globalEscalationsRoute.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { LazySidebarContent } from '@jira/navigation-apps__sidebar-nav4-sidebars-settings-global-operations/src/ui/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { globalEscalationsListInfoResource } from '@atlassian/eoc-escalation-policies/global-escalations/resources';
import type { Route } from '@atlassian/react-resource-router';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
const LazyGlobalEscalations = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-global-escalations", jiraSpaEntry: "async-jira-eoc-global-escalations" */ '@jira/eoc__global-escalations/src/index.tsx'
	).then((module) => module.GlobalEscalationsPage),
);

const GlobalEscalationsComponent = () => (
	<LazyPage
		Page={LazyGlobalEscalations}
		pageId="async-jira-eoc-global-escalations"
		shouldShowSpinner={false}
	/>
);

const getNavigationSpecifications = () => {
	return {
		sidebarId: SidebarIdOperationsGeneralConfiguration,
	};
};

export const globalEscalationsRouteEntry: Route = createEntry(globalEscalationsRoute, () => ({
	group: 'eoc',
	// eslint-disable-next-line no-restricted-syntax
	component: GlobalEscalationsComponent,
	layout: opsSettingsLayout,

	resources: [
		...getNavigationResources(),
		globalEscalationsListInfoResource,
		getConsolidationStateResource(),
		navigationSidebarGlobalResource,
	],

	navigation: {
		menuId: MenuIdSettings,
		...getNavigationSpecifications(),
	},

	forPaint: [LazySidebarContent, LazyAtlassianNavigation, LazyGlobalEscalations],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
